import { Component, ElementRef, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MaterialModule } from '../../material.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import { AbstractControl } from '@angular/forms';
import { ValidatorFn } from '@angular/forms';
import { ValidationErrors } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { operations } from '../../_model/constants';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { AbsenceRequest } from '../../_model/request/AbsenceRequest';
import { AbsenceService } from '../../_services/absence.service';
import { Absence } from '../../_model/Absence';
import { AuthenticationService } from '../../_services/authentication.service';
import { User } from '../../_model/user';
import { LookupService } from '../../_services/lookup.service';
import { DatePipe } from '@angular/common';
import { StorageService } from '../../_services/storage.service';
import { environment } from '../../../environments/environment';
import { ListDocumentRequest } from '../../_model/request/ListDocumentRequest';
import { FileNameData } from '../../_model/FileNameData';
import { AppConstants, DIALOG_OPERATIONS, PROCESS } from '../../_utils/constants';
import { UtilityService } from '../../_helpers/utility.service';
import moment from 'moment';
import 'moment-timezone';
import { AbsenceLookup } from '../../_model/AbsenceLookup';
import { AbsenceDeservedRequest } from '../../_model/request/AbsenceDeservedRequest';
import { AbsenceDeservedDto } from '../../_model/AbsenceDeservedDto';
import { DialogCloseData } from '../../_model/models';
import { EmployeeService } from 'src/app/_services/employee.service';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { HrAdminAbsenceRequest } from '../../_model/request/HrAdminAbsenceRequest';
declare var $: any;
export class DateValidators {

    static dateLessThan(dateField1: string, dateField2: string, validatorField: { [key: string]: boolean }): ValidatorFn {
        return (c: AbstractControl): { [key: string]: boolean } | null => {
            const date1 = c.get(dateField1).value;
            const date2 = c.get(dateField2).value;
            if ((date1 !== null && date2 !== null) && date1 > date2) {
                return validatorField;
            }
            return null;
        };
    }
}

export const ABSENCE_DATE_FORMAT = {
    parse: {
        dateInput: ['DD.MM.YYYY HH:mm']
    },
    display: {
        dateInput: 'DD.MM.YYYY HH:mm',
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    selector: 'app-absenceupdate',
    templateUrl: './absenceupdate.component.html',
    styleUrls: ['./absenceupdate.component.sass'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatTabsModule,
        MatSelectModule,
        MatIconModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatDialogModule,
        MaterialModule
    ]
})

export class AbsenceUpdateComponent implements OnInit {
    @ViewChild('myFile', { static: true }) myFileVariable: ElementRef;
    // absenceForm: FormGroup;
    absenceRequest: AbsenceRequest;
    submitButtonName = 'Kaydet';
    operationName: string;
    submitted = false;
    currentUser = new User();
    absenceTypeList: AbsenceLookup[];
    selectedAbsenceType: AbsenceLookup = new AbsenceLookup();
    fileList: FileNameData[] = [];
    // file upload variables
    fileData: File = null;
    fileUploadProgress: string = null;
    fileUploadRoot = environment.fileUploadPath;
    absenceExcuseReasons: any[] = [];
    isAbsenceExcuseSelected = false;
    isAbsenceOwnerManager: boolean;

    managerList: any[];
    filteredManagerList: Observable<any[]>;

    // absence deserved variables
    isAbsenceDeservedExist = false;
    absenceDeservedResponse: AbsenceDeservedDto = new AbsenceDeservedDto();
    absenceDeservedRequest: AbsenceDeservedRequest = new AbsenceDeservedRequest();

    absenceForm: FormGroup = this.formBuilder.group({
        absenceType: ['', [Validators.required]],
        absenceStartDate: ['', [Validators.required]],
        absenceEndDate: ['', [Validators.required]],
        freeDayAmount: [''],
        absenceDay: ['', [Validators.required, Validators.min(0.1)]],
        proxyManagerId: [''],
        description: ['', Validators.maxLength(500)],
        filePath: [''],
        readAndAprroved: [''],
        absenceExcuseReason: ['']
    },
        {
            validator: this.compareStartEndDate('absenceStartDate', 'absenceEndDate')
        });

    bsConfig: Partial<BsDatepickerConfig>;

    // izin sartlari
    @ViewChild('conditions', { static: true })
    conditionsTemplate: TemplateRef<any>;
    conditionModalRef: BsModalRef;

    // izin kaydi baskasi adina mi kendi adina mi olusturulacak
    isAbsenceForMe = '0';
    filteredEmployeeList: Observable<any[]>;
    employees: any;
    employeeControl = new FormControl();
    personelFullname: string;
    departmentName: string;
    additionalAbsenceDay: number = 0;

    //hr ve admin kullanicisi izin kaydini guncellediginde iscompleted alanina mudahale etmektedir
    isCompleted = this.data.isCompleted;
    radioOnay = 1;
    radioRed = -1;
    process: number;
    selectedEmployeeId: number;

    // hour minute list
    hourMinuteList: string[];
    minuteInterval: number;
    selectedHourMinuteForStart = '08:00';
    selectedHourMinuteForEnd = '17:00';
    calculatedDateTimeForStart;
    calculatedDateTimeForEnd;

    constructor(private absenceService: AbsenceService,
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        public dialogRef: MatDialogRef<AbsenceUpdateComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Absence,
        private authService: AuthenticationService,
        private lookupService: LookupService,
        private datePipe: DatePipe,
        private storageService: StorageService,
        private utilityService: UtilityService,
        private employeeService: EmployeeService,
        private modalService: BsModalService) {
        this.currentUser = authService.currentUserValue;
        moment.tz.setDefault('Etc/GMT');
    }

    compareStartEndDate(absenceStartDate: string, absenceEndDate: string) {
        return (group: FormGroup) => {
            if (moment(group.get(absenceStartDate).value, 'dd.MM.yyyy HH:00') >
                moment(group.get(absenceEndDate).value, 'dd.MM.yyyy HH:00')) {
                return group.controls[absenceEndDate].setErrors({ notEquivalent: true });
            }
        }
    }

    ngOnInit() {

        this.absenceExcuseReasons = this.lookupService.localListByLookupCode(AppConstants.ABSENCE_EXCUSE_REASON_LOOKUP_CODE);
        this.lookupService.listByLookupCode('ABSENCE_TYPE').subscribe(value => {
            this.absenceTypeList = value.responseData.items;
        }, error2 => { },
            () => {
                //if (typeof this.data === 'boolean' && this.data === true) {
                if (this.data.hasOwnProperty('isNew') && this.data.isNew) {
                    this.operationName = operations.CREATE;
                    this.absenceForm.get('absenceDay').setValue(0);
                    const currentStartDate = new Date();
                    const currentEndDate = new Date();
                    this.absenceForm.get('absenceStartDate').setValue(moment(currentStartDate, AppConstants.MOMENT_DATE_FORMAT).toDate());
                    this.absenceForm.get('absenceEndDate').setValue(moment(currentEndDate, AppConstants.MOMENT_DATE_FORMAT).toDate());
                    this.absenceForm.get('freeDayAmount').setValue(0);
                    this.absenceForm.get('absenceType').setValue(0);
                    this.calculateDateAndHourForStart();
                    this.calculateDateAndHourForEnd();
                } else {
                    this.operationName = operations.UPDATE;

                    //saat cek
                    this.selectedHourMinuteForStart = this.data.absenceStartDate.substring(this.data.absenceStartDate.length - 5);
                    this.selectedHourMinuteForEnd = this.data.absenceEndDate.substring(this.data.absenceEndDate.length - 5);

                    this.absenceForm.patchValue({
                        absenceType: this.absenceTypeList.filter(value => value.id === this.data.absenceTypeId)[0],
                        absenceStartDate: moment(this.data.absenceStartDate, AppConstants.MOMENT_DATE_FORMAT).toDate(),
                        absenceEndDate: moment(this.data.absenceEndDate, AppConstants.MOMENT_DATE_FORMAT).toDate(),
                        freeDayAmount: this.data.freeDayAmount,
                        absenceDay: this.data.absenceDay,
                        proxyManagerId: this.data.proxyManager,
                        description: this.data.description,
                        readAndAprroved: this.data.readAndAprroved,
                        absenceExcuseReason: this.absenceExcuseReasons
                            .filter(value => value.id === this.data.absenceExcuseReasonId)[0]
                    });

                    this.selectedAbsenceType = this.absenceTypeList.filter(value => value.id === this.data.absenceTypeId)[0];
                    const listDocumentRequest: ListDocumentRequest = new ListDocumentRequest('ABSENCE', this.data.id);
                    this.storageService.listDocuments(listDocumentRequest).subscribe(listResult => {
                        this.fileList = [...this.utilityService.mapPortalDocumentResponseToFileNameData(listResult.responseData.items)];

                        /**
                         * reddedilen bir kayit acildi ise bu dosyalar sifirdan yuklenmis gibi davraniyoruz
                         * yani reddedilen bir kaydin guncellenmesi demek aslinda kaydin yeniden acilmasi demek
                         * not: tum izinler sekmesinde acilan kayitlar icin bu gecerli degil
                         */
                        if (this.data.isCompleted === -1 && this.data.tabNo !== 5) {
                            this.clearFileListForRejected();
                        }
                    });
                    this.calculateDateAndHourForStart();
                    this.calculateDateAndHourForEnd();
                    this.absenceTypeChanged(true);
                }
                this.prepareSubmitButtonName();
            });

        this.employeeService.getTopManagers().subscribe(result => {

            this.managerList = result.responseData.items.sort((a, b) =>
                a.name.toLowerCase().localeCompare(b.name.toLowerCase(), 'tr'));

            this.filteredManagerList = this.absenceForm.controls.proxyManagerId.valueChanges
                .pipe(startWith(''), map(value => this.filterManagerList(value)));
        });

        this.bsConfig = { dateInputFormat: 'DD.MM.YYYY HH:00', selectFromOtherMonth: true };

        this.employeeService.getEmployeeList(-1).subscribe(result => {
            this.employees = result.responseData.items.sort((a, b) =>
                a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase(), 'tr')
            );
            this.filteredEmployeeList = this.employeeControl.valueChanges
                .pipe(startWith(''), map(value => this.filterEmployeeList(value)));
        },
            error => {
                this.toastr.error(error.error.msg, 'Hata');
            });

        this.assignPersonAndDepartmentName();

        this.employeeControl.valueChanges.subscribe(val => {
            if (val == null) {
                this.selectedEmployeeId = null;
                if (this.isAbsenceForMe === '0') {
                    this.personelFullname = this.currentUser.name + ' ' + this.currentUser.surname;
                    this.departmentName = this.currentUser.department.name;
                } else {
                    this.personelFullname = ' ';
                    this.departmentName = '';
                }
            } else {
                if (val.hasOwnProperty('id')) {
                    this.selectedEmployeeId = val.id;
                }
                if (val.hasOwnProperty('name')) {
                    this.personelFullname = val.name + ' ' + val.surname;
                }
                if (val.hasOwnProperty('department')) {
                    this.departmentName = val.department.description;
                }
            }
            this.setProxyManagerSettings(this.getEmployeeIdOfAbsence());
            if (this.absenceForm.get('absenceType').value != null) {
                this.absenceTypeChanged();
            }
        });

        this.setProxyManagerSettings(this.getEmployeeIdOfAbsence());
    }

    setProxyManagerSettings(employeeId: number) {
        this.employeeService.getEmployeeById(employeeId).subscribe(result => {
            this.isAbsenceOwnerManager = result.responseData.item.jobTitle.attribute1 === 'MANAGER' ? true : false;
            if (this.isAbsenceOwnerManager) {
                this.absenceForm.get('proxyManagerId').setValidators(Validators.required);
            } else {
                this.absenceForm.get('proxyManagerId').clearValidators();
                this.absenceForm.get('proxyManagerId').updateValueAndValidity();
            }

            this.personelFullname = result.responseData.item.name + ' ' + result.responseData.item.surname;

            this.departmentName = result.responseData.item.department.lookupValue  + " " + result.responseData.item.department.description;

        });
    }

    private filterManagerList(value: string): string[] {
        if (value != null) {
            const filterValue = (typeof value) === 'string' ? value.toLowerCase() : value;
            return this.managerList.filter(manager => (manager.name + ' ' + manager.surname).toLowerCase().includes(filterValue));
        }
    }

    createOrUpdateAbsence() {
        this.submitted = true;
        if (this.absenceForm.invalid) {
            this.getFormValidationErrors();
            return;
        }

        /**
         * kayit reddedildi degil ise guncelle diyince kayit guncellenir
         * aksi halde yeni ise kaydedilir veya
         * reddedildi durumunda ise de kaydedilir
         * cunku reddedildi
         */
        if (this.process === PROCESS.UPDATE) {
            this.update();
        } else if (this.process === PROCESS.CREATE) {
            this.create();
        }
    }

    update() {
        this.absenceRequest = {
            absenceTypeId: this.absenceForm.get('absenceType').value.id,
            absenceStartDate: this.utilityService.converDateToStringWithFormat(this.calculatedDateTimeForStart, AppConstants.MOMENT_DATETIME_FORMAT),
            absenceEndDate: this.utilityService.converDateToStringWithFormat(this.calculatedDateTimeForEnd, AppConstants.MOMENT_DATETIME_FORMAT),
            freeDayAmount: this.absenceForm.get('freeDayAmount').value,
            absenceDay: this.absenceForm.get('absenceDay').value,
            description: this.absenceForm.get('description').value,
            filePath: '',
            readAndAprroved: this.absenceForm.get('readAndAprroved').value === 1 || this.absenceForm.get('readAndAprroved').value === true ? 1 : 0,
            absenceExcuseReasonId: this.absenceForm.get('absenceExcuseReason').value == null ? 0 : this.absenceForm.get('absenceExcuseReason').value.id,
            id: this.data.id,
            fileList: this.fileList,
            proxyManagerId: this.absenceForm.get('proxyManagerId').value != null ? this.absenceForm.get('proxyManagerId').value.id : 0
        };

        if (this.data.tabNo === 5) {
            const hrAdminAbsenceRequest = new HrAdminAbsenceRequest(this.absenceRequest);
            hrAdminAbsenceRequest.isCompleted = this.isCompleted;

            this.absenceService.updateAbsenceByAdminAndHr(hrAdminAbsenceRequest).subscribe(result => {
                this.toastr.success('Güncelleme işlemi başarılı', '');
                this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.UPDATE, result.responseData.item));
            }, error => {
                this.toastr.error(error.error.msg, 'Hata');
                this.dialogRef.close();
            });
        } else {
            this.absenceService.updateAbsence(this.absenceRequest).subscribe(result => {
                this.toastr.success('Güncelleme işlemi başarılı', '');
                this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.UPDATE, result.responseData.item));
            }, error => {
                this.toastr.error(error.error.msg, 'Hata');
                this.dialogRef.close();
            });
        }
    }

    create() {

        const validationResult = this.validateAbsenceForm();
        if (!validationResult.success) {
            this.toastr.error(validationResult.description, 'Hata');
            return;
        }

        this.submitButtonName = 'Kaydediliyor...';
        this.absenceForm.disable();
        this.absenceRequest = this.absenceForm.getRawValue();

        this.absenceRequest.freeDayAmount = this.absenceForm.get('freeDayAmount').value;
        this.absenceRequest.description = this.absenceForm.get('description').value;
        this.absenceRequest.employeeId = this.getEmployeeIdOfAbsence();
        this.absenceRequest.readAndAprroved = this.absenceForm.get('readAndAprroved').value === true ? 1 : 0;
        this.absenceRequest.absenceStartDate = this.utilityService.converDateToStringWithFormat(this.calculatedDateTimeForStart, AppConstants.MOMENT_DATETIME_FORMAT);
        this.absenceRequest.absenceEndDate = this.utilityService.converDateToStringWithFormat(this.calculatedDateTimeForEnd, AppConstants.MOMENT_DATETIME_FORMAT);

        this.absenceRequest.absenceDay = this.absenceForm.get('absenceDay').value;
        this.absenceRequest.fileList = this.fileList;
        this.absenceRequest.absenceTypeId = this.absenceForm.get('absenceType').value.id;

        if (this.absenceRequest.absenceTypeId === 22) {
            this.absenceRequest.absenceExcuseReasonId = this.absenceForm.get('absenceExcuseReason').value.id;
        }

        if (this.absenceForm.get('proxyManagerId').value != null) {
            this.absenceRequest.proxyManagerId = this.absenceForm.get('proxyManagerId').value.id;
        }

        this.absenceService.saveAbsence(this.absenceRequest).subscribe(saveAbsenceResult => {
            this.toastr.success('Kaydedildi', 'Başarılı');
            this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.CREATE, saveAbsenceResult.responseData.item));
        }, error2 => {
            this.toastr.error(error2.error.msg, 'Hata');
            this.submitButtonName = 'Kaydet';
            this.absenceForm.reset();
            this.absenceForm.enable();
        }, () => {
            this.submitButtonName = 'Kaydet';
            this.absenceForm.reset();
            this.absenceForm.enable();
        });
    }


    fileProgress(fileInput: any) {
        this.fileData = fileInput.target.files[0];
    }

    uploadFile() {
        const formData = new FormData();
        formData.append('file', this.fileData);

        const fileType = this.fileData.name.substr(this.fileData.name.lastIndexOf('.') + 1);
        if (AppConstants.UPLOADABLE_FILE_TYPES.indexOf(fileType.toLowerCase()) < 0) {
            alert(AppConstants.UPLOADABLE_FILE_TYPES + ' dosya tiplerinden birini kullanabilirsiniz');
            this.fileData = null;
            return;
        }

        const fileSizeInMb = this.fileData.size / 1024 / 1024;
        if (fileSizeInMb >= AppConstants.FILE_UPLOAD_LIMIT) {
            alert('Dosya boyutu en fazla ' + AppConstants.FILE_UPLOAD_LIMIT + 'mb olmalıdır');
            this.myFileVariable.nativeElement.value = "";
            this.fileData = null;
            return;
        }
        const fileSizeInMbMin = this.fileData.size / 1024 / 1024;
        if (fileSizeInMbMin <= 0) {
            alert('Boş dosya yükleyemezsiniz');
            this.myFileVariable.nativeElement.value = "";
            this.fileData = null;
            return;
        }

        this.getBase64(this.fileData).then(value => {
            this.fileList.push(new FileNameData(this.fileData.name, value));
        });

        setTimeout(() => this.fileData = null, 500);
    }

    deleteFile(index: number) {
        /*
           guncelleme ekrani ise listeden ilgili kaydi tamamen ucurmak yerine willbedeleted alanini true yapip
           backendde ona gore silecegiz
         */
        if (this.operationName === operations.UPDATE) {
            this.fileList[index].willBeDeleted = true;
        } else {
            this.fileList.splice(index, 1);
        }
    }

    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    getFormValidationErrors() {
        Object.keys(this.absenceForm.controls).forEach(key => {
            const controlErrors: ValidationErrors = this.absenceForm.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
                });
            }
        });
    }

    assignAdditionalAbsenceDay() {
        if (this.absenceForm.get('absenceType').value != null) {
            this.additionalAbsenceDay = Number(this.absenceTypeList
                .filter(value => value.id === this.absenceForm.get('absenceType').value.id)[0].additionalAbsenceDay) || 0;
        }
    }

    absenceTypeChanged(isExecutedOnInit?: boolean) {

        this.assignAdditionalAbsenceDay();
        // reset form elements
        // hak edis hesapla (yillik ve mazeret icin)
        if (this.absenceForm.get('absenceType').value != null) {
            if (this.absenceForm.get('absenceType').value.id === 22 ||
                this.absenceForm.get('absenceType').value.id === 21) {
                this.isAbsenceDeservedExist = true;
                this.absenceDeservedRequest.absenceType = this.absenceForm.get('absenceType').value.id;
                this.absenceDeservedRequest.employeeId = this.getEmployeeIdOfAbsence();
                this.absenceService.getAbsenceDeserved(this.absenceDeservedRequest).subscribe(deservedResponse => {
                    if (deservedResponse.responseData.item == null) {
                        this.toastr.error('Hak ediş bulunamadı', 'Hata');
                        this.absenceForm.get('absenceType').setValue(null);
                        return;
                    } else {
                        this.absenceDeservedResponse = deservedResponse.responseData.item;
                    }
                    this.calculateAbsenceDay();
                    if (this.absenceDeservedResponse.totalUsedAbsenceAmount == null) {
                        this.absenceDeservedResponse.totalUsedAbsenceAmount = 0;
                    }
                });
            } else {
                this.isAbsenceDeservedExist = false;
            }
            if (this.absenceForm.get('absenceType').value.id === 22) {
                this.isAbsenceExcuseSelected = true;
            } else {
                this.isAbsenceExcuseSelected = false;
            }
            this.absenceForm.get('freeDayAmount').setValue(0);
            if (!this.isAbsenceDeservedExist) {
                if (!isExecutedOnInit) { //eger bu metot initte cagrildi ise alttaki metot cagrilmamali. yoksa patliyor!!!
                    this.clearCrucialFormElements();
                }
                this.calculateAbsenceDay();
            }
            if (this.absenceDeservedResponse.totalUsedAbsenceAmount == null) {
                this.absenceDeservedResponse.totalUsedAbsenceAmount = 0;
            }
        } else {
            this.isAbsenceDeservedExist = false;
            this.isAbsenceExcuseSelected = false;
        }

        // izin tipine gore dakika araligi belirleyip saat:dakika listesini olustur
        if (this.selectedAbsenceType != null) {
            this.minuteInterval = this.utilityService.getMinuteInterval(this.selectedAbsenceType.absenseTimeType);
            this.hourMinuteList = this.utilityService.generateHourMinuteList(this.minuteInterval);
        }
    }

    /**
     * izin kayıt ekranında ihtiyaç duyulan form elemanlarını temizler
     */
    clearCrucialFormElements() {
        const currentStartDate = new Date();
        currentStartDate.setHours(8, 0);
        this.absenceForm.get('absenceStartDate').setValue(moment(currentStartDate, AppConstants.MOMENT_DATE_FORMAT).toDate());
        const currentEndDate = new Date();
        currentEndDate.setHours(17, 0);
        this.absenceForm.get('absenceEndDate').setValue(moment(currentEndDate, AppConstants.MOMENT_DATE_FORMAT).toDate());
        this.absenceForm.get('absenceDay').setValue(null);
    }

    startDateChanged() {
        this.calculateDateAndHourForStart();
        this.calculateAbsenceDay();
        this.absenceForm.get('absenceEndDate').updateValueAndValidity();
    }

    startHourMinuteChanged() {
        this.calculateDateAndHourForStart();
        this.calculateAbsenceDay();
        this.absenceForm.get('absenceEndDate').updateValueAndValidity();
    }

    endDateChanged() {
        this.calculateDateAndHourForEnd();
        this.calculateAbsenceDay();
    }

    endHourMinuteChanged() {
        this.calculateDateAndHourForEnd();
        this.calculateAbsenceDay();
    }

    calculateDateAndHourForStart() {
        const formattedDateTimeString =
            this.datePipe.transform(this.absenceForm.get('absenceStartDate').value, 'dd.MM.yyyy') + ' ' + this.selectedHourMinuteForStart;
        this.calculatedDateTimeForStart = this.utilityService.convertStringToDateByFormat(formattedDateTimeString, AppConstants.MOMENT_DATETIME_FORMAT);
    }

    calculateDateAndHourForEnd() {
        const formattedDateTimeString =
            this.datePipe.transform(this.absenceForm.get('absenceEndDate').value, 'dd.MM.yyyy') + ' ' + this.selectedHourMinuteForEnd;
        this.calculatedDateTimeForEnd = this.utilityService.convertStringToDateByFormat(formattedDateTimeString, AppConstants.MOMENT_DATETIME_FORMAT);

    }

    freeDayChange() {
        this.calculateAbsenceDay();
    }

    /**
     * baslangic/bitis tarihleri ile calisma olmayan gun sayisi alanlari dolu oldugunda
     * izin gun sayisi hesaplanir.
     * calisma olmayan gun sayisini varsayilan olarak 0 verdigimiz icin onun kontrolune gerek yok
     */
    calculateAbsenceDay() {
        const absenceStart: number = this.calculatedDateTimeForStart.valueOf();
        const absenceEnd: number = this.calculatedDateTimeForEnd.valueOf();
        if (absenceStart != null && absenceEnd != null) {
            const startEndDiff = this.utilityService.longToHourWithDecimalFix(absenceEnd - absenceStart);
            const hourAmount = (startEndDiff - (Number(this.absenceForm.get('freeDayAmount').value) * 24));
            const absenceTime = this.utilityService.convertHourToAbsenceTime(
                hourAmount,
                this.absenceForm.get('absenceType').value.absenseTimeType,
                this.absenceForm.get('absenceType').value.id);
            /**
             * simdiye kadar kullanilan ile simdi kullanilacak olanin toplaminin kalan miktardan fazla olmamasi gerekiyor
             */
            if (!this.isAbsenceDayValid(absenceTime)) {
                return;
            }

            this.absenceForm.get('absenceDay').setValue(absenceTime);
        }
    }

    closeModal() {
        this.dialogRef.close();
    }

    validateAbsenceForm(): any {
        const result = { description: '', success: true };
        if (this.selectedAbsenceType.lookupValue === 'EXCUSE' &&
            this.selectedAbsenceType.allowedMaxTime < this.absenceForm.get('absenceDay').value) {
            result.description = 'en fazla ' + this.selectedAbsenceType.allowedMaxTime +
                (this.selectedAbsenceType.absenseTimeType === 'HOURLY' ? ' saat ' : ' gün ') +
                ' izin alabilirsiniz';
            result.success = false;
            return result;
        }

        if (this.selectedAbsenceType.id === 21 && this.absenceForm.get('freeDayAmount').value == null) {
            result.description = 'Çalışma olmayan gün boş olamaz';
            result.success = false;
            return result;
        }

        if (this.fileList.length > 2) {
            result.description = 'En fazla 2 dosya yükleyebilirsiniz';
            result.success = false;
            return result;
        }

        // izin olusturulurken dosya yukleme zorunlulugu var mi ?
        const requiredFileOnOpen = this.selectedAbsenceType.requiredFileOnOpen;
        if (requiredFileOnOpen != null && this.fileList.length === 0) {
            result.description = 'Lütfen ' + requiredFileOnOpen + ' yükleyiniz.';
            result.success = false;
            return result;
        }

        // ik kullanicisi baskasi adina kayit olustururken calisan secmeli
        if (this.currentUser.hr && this.isAbsenceForMe === '1' && this.selectedEmployeeId == null) {
            result.description = 'Lütfen çalışan seçiniz';
            result.success = false;
            return result;
        }

        return result;
    }

    isAbsenceDayValid(absenceTime) {
        if (this.selectedAbsenceType.id === 22 || this.selectedAbsenceType.id === 21) {
            if (absenceTime + this.absenceDeservedResponse.totalUsedAbsenceAmount > this.absenceDeservedResponse.remainingAmount + this.additionalAbsenceDay) {
                const total = this.absenceDeservedResponse.remainingAmount + this.additionalAbsenceDay - (this.absenceDeservedResponse.totalUsedAbsenceAmount || 0);
                this.toastr.warning('En fazla ' + total + ' ' +
                    (this.selectedAbsenceType.absenseTimeType === 'HOURLY' ? 'saat' : 'gün') + ' izin kullanabilirsiniz', 'Uyarı');
                this.absenceForm.get('absenceEndDate').setValue(this.absenceForm.get('absenceStartDate').value);
                if (this.selectedAbsenceType.id === 22) {
                    this.selectedHourMinuteForEnd = this.selectedHourMinuteForStart;
                }
                this.endDateChanged();
                return false;
            }
        }
        return true;
    }

    displayFn(manager: any): string | undefined {
        return manager ? manager.name + ' ' + manager.surname : undefined;
    }

    setReadonlyToHourAndMinute() {
        setTimeout(() => {
            $("input[formcontrolname='minute']").prop('readonly', true);
            $("input[formcontrolname='hour']").prop('readonly', true);
        }, 3000);
    }

    /**
     * guncelle durumunda ise ve bekliyor durumunda ise guncelle
     * guncelle durumunda ise ve reddedildi durumunda ise yenile ve kaydet
     * kaydet durumunda ise kaydet olacak
     */
    prepareSubmitButtonName() {
        if (this.data.tabNo === 5) {
            this.process = PROCESS.UPDATE;
            this.submitButtonName = 'GÜNCELLE';
        } else {
            if (this.data.isNew === false && this.data.isCompleted !== -1) {
                this.process = PROCESS.UPDATE;
                this.submitButtonName = 'GÜNCELLE';
            } else if (this.data.isNew === false && this.data.isCompleted === -1) {
                this.process = PROCESS.CREATE;
                this.submitButtonName = 'YENİLE VE KAYDET';
            } else {
                this.process = PROCESS.CREATE;
                this.submitButtonName = 'KAYDET';
            }
        }
    }

    clearFileListForRejected() {
        //eger reddedildi kaydi acildi ise dosyalarin attribute larini sifirla, yeni kaydedilecek gibi olsun
        this.fileList.forEach((value, index, array) => {
            array[index].willBeDeleted = false;
            array[index].alreadyStored = false;
        });
    }

    openConditionsTemplate() {
        this.conditionModalRef = this.modalService.show(this.conditionsTemplate);
    }

    private filterEmployeeList(value: any): string[] {
        let filterValue = '';
        if (value != null) {
            if (value.hasOwnProperty('fullName')) {
                filterValue = this.utilityService.toTurkishLowerCase(value.fullName);
            } else {
                filterValue = this.utilityService.toTurkishLowerCase(value);
            }
        }
        return this.employees.filter(employee =>
            this.utilityService.toTurkishLowerCase(employee.fullName).includes(filterValue));
    }

    displayFn2(employee: any): string | undefined {
        return employee ? employee.fullName : undefined;
    }

    assignPersonAndDepartmentName() {
        if (!this.data.isNew) {
            this.personelFullname = this.data.name + ' ' + this.data.surname;
            this.departmentName = this.data.departmentName;
        } else {
            if (!(this.currentUser.hr && this.isAbsenceForMe === '1')) {
                this.personelFullname = this.currentUser.name + ' ' + this.currentUser.surname;
                this.departmentName = this.currentUser.department.name;
            } else {
                this.personelFullname = '';
                this.departmentName = '';
            }
        }
    }

    employeeChange(event) {
        //this.assignPersonAndDepartmentName();
        if (this.absenceForm.get('absenceType').value != null) {
            this.absenceTypeChanged();
        }
    }

    absenceOwnerChange() {
        this.assignPersonAndDepartmentName();
        this.absenceForm.reset();
        this.isAbsenceDeservedExist = false;
        this.isAbsenceExcuseSelected = false;
        this.employeeControl.setValue(null);
    }

    // ik baskasi adina cagri acarsa o secilen kisinin id sini atiyoruz
    getEmployeeIdOfAbsence() {
        if (this.data.isNew) { // yeni kayit
            if (this.currentUser.hr && this.isAbsenceForMe === '1') {
                return this.selectedEmployeeId != null ? this.selectedEmployeeId : this.currentUser.employeeId;
            } else {
                return this.currentUser.employeeId;
            }
        } else { // guncelleme
            if (this.selectedEmployeeId == null) {
                return this.data.employeeId;
            } else {
                return this.selectedEmployeeId;
            }
        }
    }

}
